(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.tippy = {
    attach: function (context, settings) {

      tippy.setDefaults({
        arrow: true,
        delay: 40,
        theme: 'my-tippy',
        interactive: true,
      });
      tippy('[data-tippy-content]');

    },
  };

})(jQuery, Drupal, window, document);
